import gql from 'graphql-tag';

import POSMetaDataFragment from 'shared/graphql/product/pos-meta-data-fragment.gql';

const adminBaseProductFragment = gql`
  ${POSMetaDataFragment}

  fragment adminBaseProductFragment on Products {
    id
    _id
    AdditionalOptions
    brand {
      _id
      id
      imageUrl
      isGlobal
      name
    }
    brandName
    CBD
    CBDContent {
      unit
      range
    }
    comingSoon
    connectedAt
    connectedBy
    createdAt
    createdBy
    dateCreated
    Description
    descriptionHtml
    DispensaryID
    dispensaryName
    duplicatedProductId
    effects
    enterpriseProductId
    Image
    images {
      _id
      url
      origin
      description
      active
      userId
    }
    imgixSettings {
      productCard {
        border
        mark
        markscale
        markpad
        fit
      }
      productModal {
        border
        mark
        markscale
        markpad
        fit
      }
    }
    integrationKey
    matchedLibraryItemsConfidence
    medicalOnly
    medicalPrices
    medicalSpecialPrices
    Name
    Options
    limitsPerCustomer {
      key
      value
    }
    manualInventory {
      option
      inventory
    }
    originalPrices
    overrides
    POSMetaData {
      ...POSMetaDataFragment
    }
    preCropImage
    Prices
    wholesalePrices
    rawOptions
    rawPrices
    rawMedicalPrices
    recOnly
    recPrices
    recSpecialPrices
    preTaxRecPrices
    preTaxMedPrices
    reviewedAt
    reviewedBy
    score
    special
    specialData {
      bogoSpecials {
        applyRewardsToConditions
        excludeConditionItemsFromRewards
        bogoConditionLogicOperator
        bogoConditions {
          _id
          brandId
          brandIds
          brandName
          brandNames
          categoryIds
          categoryName
          categoryNames
          enterpriseProductIds
          exclusions {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            enterpriseProductIds
            inventoryTags
            matchOperator
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weights
            weightOperator
          }
          inventoryTags
          productGroup
          productId
          productIds
          productTags
          quantity
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weight
          weightOperator
        }
        bogoRewardLogicOperator
        bogoRewards {
          _id
          brandId
          brandIds
          brandName
          brandNames
          categoryIds
          categoryName
          categoryNames
          dollarDiscount
          enterpriseProductIds
          exclusions {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            enterpriseProductIds
            inventoryTags
            matchOperator
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weights
            weightOperator
          }
          inventoryTags
          productGroup
          productId
          productIds
          percentDiscount
          productTags
          quantity
          strainIds
          subcategoryIds
          subcategoryNames
          targetPrice
          vendorIds
          weight
        }
        createdBy
        directPOSProductIdMapping
        rawPOSWeightMapping
        discountToCart {
          _id
          enabled
          discountType
          value
        }
        discountBehavior
        discountStacking
        discountPrecedence
        endStamp
        excludedProducts {
          conditions {
            _id
            key
            Name
          }
          rewards {
            _id
            key
            Name
          }
        }
        isRecurring
        itemsForAPrice {
          _id
          enabled
          value
        }
        discountBundle {
          _id
          applyTo
          discountType
          enabled
          limit
          value
        }
        menuType
        minorVersion
        nonStackingBehavior
        paymentRestrictions {
          payByBankSignupIncentive
        }
        recurringEndDate
        redemptionLimit
        specialId
        specialName
        specialType
        stackingBehavior
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        version
      }
      saleSpecials {
        createdBy
        directPOSProductIdMapping
        rawPOSWeightMapping
        discount
        discountStacking
        dollarDiscount
        eligibleProductOptions
        menuType
        minorVersion
        nonStackingBehavior
        paymentRestrictions {
          payByBankSignupIncentive
        }
        percentDiscount
        saleDiscounts {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          discountAmount
          discountType
          enterpriseProductIds
          exclusions {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            enterpriseProductIds
            inventoryTags
            matchOperator
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weights
            weightOperator
          }
          inventoryTags
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        specialName
        source
        sourceId
        specialId
        specialRestrictions
        specialType
        stackingBehavior
        stackingMode
        targetPrice
        version
      }
    }
    Status
    strainType
    subcategory
    subcategories
    syncedAt
    updatedAt
    updatedBy
    THC
    THCContent {
      unit
      range
    }
    type
    vapeTaxApplicable
    weight
    featured {
      current
      startTime
      endTime
    }
    isBelowThreshold
    isBelowKioskThreshold
    optionsBelowThreshold
    optionsBelowKioskThreshold
    adminEdits {
      updatedAt
      updatedBy
    }
    brandLogo
    brandDescription
    cName
    brandId
    bottleDepositTaxCents
  }
`;

export default {
  adminBaseProductFragment,
};
